<template>
	<pagina-erro
		titulo="Página não encontrada"
		icone="fa fa-eye-slash"
		imagemTexto="centralservidor-logo-texto.png"
		imagem="centralservidor-logo.png"
		texto="A página que você esta tentando acessar não foi encontrada.
			Por favor, verifique o link digitado ou entre em contato
			com o administrador." >
	</pagina-erro>
</template>

<script >
import PaginaErro from '@/components/pagina-erro'

export default {
	name: 'NaoEncontrado',
	components: {
		PaginaErro
	}
}
</script>



// WEBPACK FOOTER //
// index.vue?0d3e72ae